import styles from "./Order.module.css"
import { PaymentSuccessModal ,OrderProductListDetailsCard ,PaymentDetailsCard,PaymentFailureModal
     ,PaymentInstrumentDetailsCard  } from "../../components"
import CrossSign from "../../asset/icons/whiteCross.png"
import CongratsImage from "../../asset/icons/congratsImage.png"
import forward from "../../asset/icons/whiteForwardCircle.png"
import whatsappIcon from "../../asset/icons/whatsapp.png"
import { ErrorFallback } from "../../components/Error/Error";
import { Loading } from "../../components/Loading/Loading";
import cx from 'classnames';

import Api from "../../utils/Api/Api";
import { useNavigate, useSearchParams } from "react-router-dom";
import React , {useState, useEffect} from "react";
import UTMTracker from "../../utils/UTMTracker";
import { trackPurchaseCompleted } from '../../utils/analyticsService';


export const Order = (props)=>{
    const [showModal,setShowModal] = useState(false);
    const [searchParams] = useSearchParams();
    const order_id = searchParams.get("order_id")
    const [loading,setLoading] = useState(true);
    const [hasError,setError] = useState(false);
    const [orderDetails,setOrderDetails] = useState({});

    const navigate = useNavigate()
    const toggleModal = ()=>{
        localStorage.setItem('order_id', order_id)
        setShowModal((pre_state)=>(!pre_state))
    }

    useEffect(()=>{
        // Inject a direct script to fetch IP and store it, avoiding any React/CORS issues
        if (!localStorage.getItem('user_ip_address')) {
            // Only inject if we don't already have the IP
            const ipifyScript = document.createElement('script');
            ipifyScript.innerHTML = `
                // Direct script execution in the browser
                var ipifyRequest = new XMLHttpRequest();
                ipifyRequest.open('GET', 'https://api.ipify.org/?format=json', true);
                ipifyRequest.onload = function() {
                    if (this.status >= 200 && this.status < 400) {
                        // Success
                        var resp = JSON.parse(this.response);
                        console.log('IP address fetched directly:', resp.ip);
                        localStorage.setItem('user_ip_address', resp.ip);
                    }
                };
                ipifyRequest.onerror = function() {
                    console.error('Error fetching IP address');
                };
                ipifyRequest.send();
            `;
            document.body.appendChild(ipifyScript);
            
            // Remove the script after execution to clean up
            setTimeout(() => {
                if (ipifyScript.parentNode) {
                    ipifyScript.parentNode.removeChild(ipifyScript);
                }
            }, 1000);
        }
        
        const fetchCartData = async ()=>{
            try {
                // Use a slight delay to ensure IP fetch completes
                if (!localStorage.getItem('user_ip_address')) {
                    await new Promise(resolve => setTimeout(resolve, 500));
                }
                
                console.log("Fetching order details for order ID:", order_id);
                
                // ========== TRY V4 API FIRST ==========
                try {
                    console.log("Attempting to process payment with V4 API");
                    const payload = { order_id };
                    const { data: paymentResult } = await Api.ProcessPaymentV4(payload);
                    console.log("V4 Payment Result:", paymentResult);
                    
                    if (paymentResult && paymentResult.order_id) {
                        // Get order details using payment_id from V4 response
                        const { data: orderDetailDirect } = await Api.GetOrderDetailsFromPaymentId({
                            payment_order_id: paymentResult.payment_id
                        });
                        
                        if (orderDetailDirect && orderDetailDirect.length) {
                            console.log("Successfully fetched order details with V4 API");
                            const orderData = orderDetailDirect[0];
                            setOrderDetails(orderData);
                            
                            // Check if payment is successful
                            if (paymentResult.status === 'paid' && paymentResult.is_purchase_done) {
                                // Get IP from localStorage for CAPI
                                const userIP = localStorage.getItem('user_ip_address') || '';
                                console.log('Using stored IP for CAPI:', userIP);
                                
                                // Track purchase completion with centralized service
                                console.log('Order data:', JSON.stringify(orderData));
                                await trackPurchaseCompleted(orderData, {
                                    phone: orderData?.user?.phone_number,
                                    email: orderData?.user?.email || '',
                                    clientIp: userIP
                                });

                                if(localStorage.getItem('order_id') === order_id) {
                                    setShowModal(2);
                                } else {
                                    setShowModal(1);
                                }
                                setLoading(false);
                                return; // Success! Exit here
                            }
                        }
                    }
                    
                    throw new Error("V4 API didn't return valid order details");
                } catch (v4Error) {
                    console.warn("V4 API failed, falling back to V3:", v4Error);
                    // Fall back to V3 flow below
                }
                
                // ========== FALLBACK TO V3 ==========
                console.log("Using V3 fallback flow for order:", order_id);
                let params = {
                    order_id
                }
                let { data: confirmationData } = await Api.GetOrderConfirmation(params);

                let paymentId = {
                    payment_order_id: confirmationData.payment_id
                }
                let { data: orderDetail } = await Api.GetOrderDetailsFromPaymentId(paymentId);
                if(orderDetail && orderDetail.length){
                    setOrderDetails(orderDetail[0]);
                    if(confirmationData.status === 'CHARGED' || 
                       confirmationData.payment_gateway_response?.resp_code === 'SUCCESS') {
                        
                        // Get IP from localStorage for CAPI
                        const userIP = localStorage.getItem('user_ip_address') || '';
                        console.log('Using stored IP for CAPI:', userIP);
                        
                        // Track purchase completion with centralized service
                        const orderData = orderDetail[0];
                        console.log('Order data:', JSON.stringify(orderData));
                        await trackPurchaseCompleted(orderData, {
                            phone: orderData?.user?.phone_number,
                            email: orderData?.user?.email || '',
                            clientIp: userIP
                        });

                        if(localStorage.getItem('order_id') === order_id) {
                            setShowModal(2);
                        } else {
                            setShowModal(1);
                        }
                    } else {
                        setTimeout(() => {
                            navigate('/checkout?status=failed');
                        }, 5000);
                        return;
                    }
                } else {
                    setTimeout(() => {
                        navigate('/checkout?status=failed');
                    }, 5000);
                    return;
                }
            }
            catch(err) {
                console.error('Error tracking purchase:', err);
                setError(true);
            }
            setLoading(false)
        }
        fetchCartData();
    },[])
    
    if(hasError) {
        return <ErrorFallback />
    }
    if(loading) {
        return <Loading />
    }

    const {new_ordered_items, payment, amount_saved_dict, total_amount, details, bundle:bundleDetails} = orderDetails;
    let bundle = bundleDetails ? true : false;
    const OrderInfo = (i) => {
        navigate(`/orderdetail/${new_ordered_items[i ? i : 0].id}`);
    }

    const paymentDetails = {mrp_price: bundle? bundleDetails.mrp_price: new_ordered_items[0]?.subscription_plan?.mrp_price,
         useFleekCoin: details?.coin_value_used,
         actual_discounted_cost: payment.amount,
         coin_value_reserved: details?.coin_value_used,
         cost:bundle ? bundleDetails.mrp_price - amount_saved_dict.amount_saved + details?.coin_value_used : new_ordered_items[0]?.cost - (total_amount - payment.amount),
        }

        if(showModal === 0 ) {
            return <PaymentFailureModal toggleModal={toggleModal}/>
        }
        
    const openWhatsApp = () => {
        window.open(`https://wa.me/919148477518`, '_blank');
    }

    return(
        <div>

            {showModal === 1 && <PaymentSuccessModal payment={payment} amount_saved_dict= {amount_saved_dict} toggleModal={toggleModal}/>}
            {
            <>
                <div className={styles.headcontent}>
                    {/* <NavBar/> */}
                </div>
                <div className={(showModal === 1 || showModal === 0) ? cx(styles.content, styles.opacity25): styles.content}>
                    <div className={styles.header}>
                        <img onClick={() => {
                            navigate('/marketplace');
                        }} className={styles.crossSign} src={CrossSign} alt="CrossSign"/>
                        <p className={styles.headText}>Order Confirmed</p>
                        <p onClick={() => navigate('/support')} className={styles.helpText}>HELP</p>
                    </div>
                    <div className={styles.congratsContainer}>
                        <img className={styles.CongratsImage} src={CongratsImage} alt="CongratsImage" />
                        <p className={styles.congratsHead}>Congratulations!</p>
                        <p className={styles.congratsSubhead}>We received your order for {new_ordered_items?.length} items</p>
                    </div>
                    <div className={styles.detailContainer}>
                        <div className={styles.cardContainer}>
                            <OrderProductListDetailsCard bundle={bundle} OrderInfo={OrderInfo} orderDetails={new_ordered_items}/>
                        </div>
                        <div className={styles.otherDetail}>
                            <PaymentDetailsCard cartData={paymentDetails} useFleekCoin={paymentDetails.useFleekCoin} />
                            <PaymentInstrumentDetailsCard payment={payment}/>
                            
                            {/* WhatsApp Support Card */}
                            <div className={styles.whatsappCard} onClick={openWhatsApp}>
                                <div className={styles.whatsappContent}>
                                    <img src={whatsappIcon} alt="WhatsApp" className={styles.whatsappIcon} />
                                    <div className={styles.whatsappText}>
                                        <p className={styles.whatsappTitle}>Need activation help?</p>
                                        <p className={styles.whatsappSubtitle}>WhatsApp us now</p>
                                        <p className={styles.whatsappNumber}>+91 91484 77518</p>
                                    </div>
                                </div>
                                <img src={forward} alt="forward" className={styles.whatsappForward}/>
                            </div>

                            <div className={styles.mobileButtonContainer}>
                                <button className={styles.nextButton}
                                    onClick={() => bundle 
                                        ? navigate('/myorder') 
                                        : OrderInfo()
                                    }
                                >
                                    SEE ORDER DETAILS
                                    <img className={styles.forward} alt="forward" src={forward}/>
                                </button>
                            </div>
                        </div>
                    </div>   
                </div>
            </>
            }
        </div>
    )
}